import Tab from '@sharedComponents/Tab';

import * as style from './style.module.css';

const TabBar = ({ tabs, onClick }) => {
    return (
        <div className={style.tabBar}>
            {tabs.map((tab, index) => (
                <Tab key={index} {...tab} onClick={() => onClick(index)} />
            ))}
        </div>
    );
};

export default TabBar;
